// extracted by mini-css-extract-plugin
export default {"options-message":"category-options__options-message--YcIJt","optionsMessage":"category-options__options-message--YcIJt"};